export default class Snackbar {
	constructor(args) {
		this.closeButton = !!args.closeButton;
		this.text = args.text || '';
		this.timeout = args.timeout ? args.timeout : this.closeButton ? 0 : 8000;
		this.type = args.type || null;
	}
}
